export default {
  bankMandateList: null,
  bankMandateStatus: null
}
